import { IBaseModel, BaseModel } from '../base.model';

export interface ITicket extends IBaseModel {
  subject?: string;
  origin_demand?: 'call' | 'phone'; // TODO Fix not call or phone
  is_private?: boolean;
  pb_type?: string;
  fk_ticket_block?: number;
  fk_ticket_apartment?: number;
  apartments?: number[];
  fk_ticket_agency?: number;
  fk_ticket_character_problem?: number;
  fk_character_problem_level_2?: number;
  equipments?: number[];
  description?: string;
  //creator?: number;
  declarant?: number;
  owners?: number[];
  caretakers?: number[];
  managers?: number[];
  managers_assigned?: number[];
  mandates?: number[];
  quotes?: number[];
  tenants?: any;
  participants?: number[];
  channel_public?: number;
  channels?: any;
  force_external_apartment?: boolean | undefined;
  fk_ticket_priority?: number;
  fk_ticket_substatus?: number;
  apartment_zone?: number[];
  mileage?:number;
  availability?:string;
  ticket_availability_mileage?:{mileage?:number, availability?:string}
}

export class TicketDto extends BaseModel implements ITicket {
  subject?: string;
  origin_demand?: 'call' | 'phone';
  is_private?: boolean;
  pb_type?: string;
  fk_ticket_block?: number;
  fk_ticket_apartment?: number;
  apartments?: number[];
  fk_ticket_agency?: number;
  fk_ticket_character_problem?: number;
  fk_character_problem_level_2?: number;
  equipments?: number[];
  description?: string;
  //creator?: number;
  declarant?: number;
  owners?: number[];
  caretakers?: number[];
  managers?: number[];
  managers_assigned?: number[];
  mandates?: number[];
  quotes?: number[];
  tenants?: any;
  participants?: number[];
  channels: any;
  force_external_apartment?: boolean | undefined;
  fk_ticket_priority?: number;
  fk_ticket_substatus?: number;
  apartment_zone?: number[];
  mileage?:number
  availability?:string
  ticket_availability_mileage?:{mileage?:number, availability?:string}

  /**
   *
   */
  constructor(opt: ITicket = {}) {
    super(opt);
  }
}



// WEBPACK FOOTER //
// ./src/models/ticket/ticket.model.ts